import { FC, useId } from 'react';
import { css } from '@bts-web/utils-style-engine';

export interface CheckboxSingleProps {
  checked?: boolean;
  onChange?: () => void;
  name?: string;
  label?: string;
  disabled?: boolean;
  labelPosition?: 'left' | 'right';
}

export const CheckboxSingle: FC<CheckboxSingleProps> = ({
  onChange,
  checked = false,
  label,
  name,
  disabled = false,
  labelPosition = 'left',
}) => {
  const uniqueId = useId();

  return (
    <label
      className={css({
        display: 'inline-flex',
        flexDirection: labelPosition === 'left' ? 'row' : 'row-reverse',
        alignItems: 'center',
        gap: 'extra_small_2',
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: 'label.large',
        userSelect: 'none',
        lineHeight: 1,
      })}
      htmlFor={uniqueId}
    >
      {label && <span>{label}</span>}

      <input
        id={uniqueId}
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        className={css({
          position: 'absolute',
          opacity: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          height: 0,
          width: 0,
        })}
        onChange={() => {
          if (!disabled) {
            onChange?.();
          }
        }}
      />

      <span
        className={css({
          display: 'inline-block',
          flexShrink: 0,
          position: 'relative',
          height: '20px',
          width: '20px',
          lineHeight: 1,
          backgroundColor: disabled
            ? '#f0f0f0'
            : checked
              ? 'rgba(0, 0, 0, 0.65)'
              : 'transparent',
          borderRadius: '4px',
          border: '2px solid rgba(0, 0, 0, 0.35)',
          _after: {
            content: '""',
            position: 'absolute',
            display: checked ? 'block' : 'none',
            insetInlineStart: '6px',
            top: '2px',
            width: '5px',
            height: '11px',
            border: 'solid white',
            borderWidth: '0 2px 2px 0',
            transform: 'rotate(45deg)',
          },
        })}
      />
    </label>
  );
};
